import * as React from 'react'
import type { SvgIconProps } from '@mui/material'
import { BaseIcon } from '../BaseIcon'
export const BarcodeIcon = (props: SvgIconProps) => (
  <BaseIcon fill="none" {...props}>
    <path fill="currentColor" d="M5 9v6h3V9zM14 15V9h3v6zM11 9v6h2V9zM9 15V9h1v6zM18 9v6h1V9z" />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2 5a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h20a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1zm1 12V7h18v10z"
      clipRule="evenodd"
    />
  </BaseIcon>
)
